import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import urologyBg1 from '../../assets/img/clinic/5.png';
import urologyBg2 from '../../assets/img/clinic/6.png';
import { useState, useEffect } from 'react';
import Footer from '../Footer/Footer';

const Urology = () => {
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [urologyBg1, urologyBg2];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Urology</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Urology</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>Urology at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>Urology at Hitkari Hospital</h3>
                                     <p>The Urology Department at Hitkari Hospital is dedicated to delivering world-class medical care for conditions affecting the urinary tract and the male reproductive system. Our team of expert urologists, supported by state-of-the-art diagnostic and treatment technologies, ensures comprehensive and personalized care for every patient.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>Scope of Services</h3>
                                      <br />
                                      <p>We address a broad spectrum of urological conditions, providing expertise in:</p>
                                     <ul>
                                         <li>Kidney Stones: Utilizing advanced lithotripsy, laser treatments, and minimally invasive surgical techniques to remove or break down stones effectively and painlessly.</li>
                                       <li>Prostate Disorders: Managing benign prostatic hyperplasia (BPH), prostatitis, and prostate cancer with evidence-based therapies and modern surgical approaches.</li>
                                        <li>Urinary Tract Infections (UTIs): Diagnosing and treating acute and chronic infections, including recurrent UTIs, with a focus on long-term prevention.</li>
                                         <li>Urological Cancers: Offering specialized care for kidney, bladder, testicular, and prostate cancers, including chemotherapy, immunotherapy, and robotic-assisted surgeries.</li>
                                        <li>Incontinence: Providing advanced diagnostic evaluations and treatments for urinary incontinence, ensuring improved quality of life.</li>
                                        <li>Erectile Dysfunction and Male Infertility: Offering comprehensive evaluations and innovative treatments to address reproductive health concerns with confidentiality and care.</li>
                                          <li>Pediatric Urology: Treating congenital and acquired urological issues in children with a compassionate and family-centered approach.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Cutting-Edge Technology</h3>
                                    <br />
                                       <p>At Hitkari Hospital, we integrate the latest technological advancements, including:</p>
                                       <ul>
                                           <li>Robotic-Assisted Surgeries for enhanced precision and quicker recovery.</li>
                                            <li>Endoscopic Procedures for minimally invasive diagnosis and treatment.</li>
                                          <li>Urodynamic Studies for detailed assessment of bladder function.</li>
                                           <li>Advanced Imaging Techniques such as CT scans and ultrasounds for accurate diagnoses.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Our Approach</h3>
                                    <br />
                                    <p>Our Urology Department emphasizes a holistic and patient-centric approach. From diagnosis to treatment and follow-up care, our team ensures that every patient receives individualized attention. We believe in empowering patients with knowledge, offering detailed consultations to help them understand their condition and treatment options.</p>
                                </div>
                                <div className="terms-text">
                                    <h3>Why Choose Hitkari Hospital for Urology Care?</h3>
                                    <ul>
                                         <li>Expertise: Our urologists are highly trained and experienced in handling even the most complex cases.</li>
                                           <li>Minimally Invasive Techniques: We prioritize methods that reduce pain, recovery time, and hospital stays.</li>
                                            <li>Comprehensive Care: From preventive screenings to advanced treatments, we cover all aspects of urological health.</li>
                                           <li>Patient Comfort: With private consultation rooms, a compassionate staff, and modern facilities, we aim to make every visit comfortable and reassuring.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                     <p>At Hitkari Hospital, we are committed to advancing urological health through innovation, compassion, and expertise. Trust us to provide you with exceptional care tailored to your unique needs.</p>
                                    <p>Contact us today to schedule an appointment or learn more about our services. Let us help you on your journey to better health and well-being!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default Urology;